// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "hotel-detail" + "." + "8a1eb384" + ".css";
};